import { useEffect, useState } from 'react';
import moment from 'moment';

import { MainContent, PageHeading } from '../../components/Shell/Content';
import { DataTable } from '../../components/nextgen';

import useAsync from '../../hooks/useAsync';

import { getArchivedAssetsAdmin } from '../../api/admin';

const ArchivedAssets = () => {
	const [page, setPage] = useState(1);

	const {
		value: archivedData,
		execute: refreshArchivedAssets,
		status: loadingStatus,
	} = useAsync(getArchivedAssetsAdmin, { immediate: false });

	useEffect(() => {
		refreshArchivedAssets({ page: page - 1, limit: 25 });
	}, [page]);

	const isLoading = loadingStatus === 'pending';

	const columns = [
		{
			key: 'asset',
			header: 'Asset',
			sortable: false,
			render: (row) => (
				<div>
					<div className="text-gray-900 font-medium">
						{row.manufacturer?.name || row.manufacturerName || ''}{' '}
						{row.model?.name || row.modelName || ''}
					</div>
					<div className="text-gray-500 text-xs">
						S/N: {row.serialNumber || '-'}
					</div>
				</div>
			),
		},
		{
			key: 'tag',
			header: 'Tag',
			width: '120px',
			sortable: false,
			render: (row) => (
				<span className="text-gray-700 font-mono text-xs">
					{row.tag || '-'}
				</span>
			),
		},
		{
			key: 'organization',
			header: 'Organization',
			width: '200px',
			sortable: false,
			render: (row) => (
				<div>
					<div className="text-gray-900">{row.organization?.name || '-'}</div>
				</div>
			),
		},
		{
			key: 'archivedAt',
			header: 'Archived At',
			width: '180px',
			sortable: false,
			render: (row) => (
				<div>
					{row.archivedAt ? (
						<>
							<div className="text-gray-900">
								{moment(row.archivedAt).format('MMM D, YYYY')}
							</div>
							<div className="text-gray-500 text-xs">
								{moment(row.archivedAt).format('h:mm A')}
							</div>
							<div>{moment(row.archivedAt).fromNow()}</div>
						</>
					) : (
						<span className="text-gray-400">-</span>
					)}
				</div>
			),
		},
		{
			key: 'archivedBy',
			header: 'Archived By',
			width: '200px',
			sortable: false,
			render: (row) => (
				<div>
					{row.archivedBy ? (
						<>
							<div className="text-gray-900">
								{row.archivedBy.firstName} {row.archivedBy.lastName}
							</div>
							<div className="text-gray-500 text-xs">
								{row.archivedBy.email}
							</div>
						</>
					) : (
						<span className="text-gray-400">-</span>
					)}
				</div>
			),
		},
	];

	return (
		<MainContent>
			<div className="flex items-center justify-between mb-4">
				<PageHeading divider={false}>Archived Assets</PageHeading>
			</div>

			<div className="border border-gray-200 rounded-lg overflow-hidden">
				<DataTable
					data={archivedData?.rows || []}
					columns={columns}
					loading={isLoading}
					pagination
					serverSidePagination
					currentPage={page}
					totalItems={archivedData?.count || 0}
					onPageChange={setPage}
					pageSize={25}
					searchable
					searchPlaceholder="Search archived assets..."
					searchFields={[
						'serialNumber',
						'tag',
						'manufacturerName',
						'modelName',
					]}
					emptyTitle="No archived assets found"
					emptyDescription="There are no archived assets across all organizations"
					hoverable
					bordered={false}
				/>
			</div>
		</MainContent>
	);
};

export default ArchivedAssets;
